import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=d38784c6&scoped=true"
import script from "./OfferCard.vue?vue&type=script&lang=js"
export * from "./OfferCard.vue?vue&type=script&lang=js"
import style0 from "./OfferCard.vue?vue&type=style&index=0&id=d38784c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38784c6",
  null
  
)

export default component.exports